import React, {useRef, useState, useEffect} from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import {injectIntl} from 'react-intl';
import {SavedFiltersSection} from './saved_filters_section';
import FilterQueryContent, {FilterQueryContentQuery} from './FilterQueryContent';
import {Container, CloseContainer, FilterButtonWrapper, QueryRenderContainer} from './filter.styled';
import {CrossIconOld} from 'web-components';
import {FILTER_SECTIONS} from './dropdown_section';
import Util from '../../util/util';
import {ClickAwayListener} from '@material-ui/core';
import {saveFilters, filtersToObject, filtersToArray, getFilterFunctions} from './filter_logic';
import {renameSavedFilter, deleteSavedFilter} from './filter_logic';
import {Button, FilterIcon} from 'web-components';
import tracking from '../../../../tracking';
import Moment from 'moment';
import {FilterSlider} from './FilterSlider';
import ForecastQueryRenderer from '../../../../ForecastQueryRenderer';
import InlineLoader from '../inline-loader/inline_loader';
export {FILTER_SECTIONS};
import {hasFeatureFlag} from '../../../../forecast-app/shared/util/FeatureUtil';

// See bottom of file for important implementation details
const FilterWrapper = ({
	intl,
	iconOnly,
	noMenu,
	viewer,
	taskFilters,
	timeRegFilters,
	invoiceFilters,
	peopleFilters,
	projectFilters,
	skillFilters,
	labelFilters,
	appliedFiltersName,
	useSavedReport,
	preAppliedFilters,
	defaultSection,
	onFiltersChange,
	filterSection,
	projectId,
	projectGroupId,
	companyProjectGroupId,
	companyProjectId,
	userpilot,
	cy,
}) => {
	if (
		hasFeatureFlag('no_time_reg') &&
		(projectFilters.includes('projectType') || projectFilters.includes('projectBudgetType'))
	) {
		const projectBudgetFilterIndex = projectFilters.includes('projectType')
			? projectFilters.indexOf('projectType')
			: projectFilters.indexOf('projectBudgetType');
		projectFilters.splice(projectBudgetFilterIndex, 1);
	}
	const containerRef = useRef();
	const [appliedFiltersList, setAppliedFiltersList] = useState([]);
	const [show, setShow] = useState(false);
	const [savingFilter, setSavingFilter] = useState(false);
	const [renamingFilter, setRenamingFilter] = useState();
	const savedFiltersTmp = [];
	viewer.filters.edges.forEach(filter => {
		if (filter.node.value && filter.node.name) {
			if (filterSection && filter.node.section !== filterSection) {
				return;
			}
			savedFiltersTmp.push({
				id: filter.node.id,
				name: filter.node.name,
				value: filtersToArray(JSON.parse(filter.node.value)),
				isFavoured: filter.node.isFavoured,
				updatedAt: Moment(filter.node.updatedAt),
			});
		}
	});

	//sort them by dates,  the newest one first
	const savedFilters = savedFiltersTmp.sort((a, b) => b.updatedAt.valueOf() - a.updatedAt.valueOf());

	useEffect(() => {
		const storedFilters = preAppliedFilters || JSON.parse(localStorage.getItem(appliedFiltersName));
		tracking.trackFilter(storedFilters);
		const filtersList = filtersToArray(storedFilters);
		setAppliedFiltersList(filtersList);
	}, []);

	const handleCloseFilter = () => {
		setShow(false);
		tracking.trackFilter(filtersToObject(appliedFiltersList));
	};

	const changeAppliedFilters = filters => {
		const filterObject = filtersToObject(filters);
		!useSavedReport && Util.localStorageSetItem(appliedFiltersName, JSON.stringify(filterObject));
		setAppliedFiltersList(filters);
		onFiltersChange(filterObject, getFilterFunctions(filterObject));
	};

	// Adding and removing a single applied filter
	const onAddFilter = (section, filterType, ids) => {
		const newFilters = ids.map(id => ({section, filterType, id}));
		changeAppliedFilters(appliedFiltersList.concat(newFilters));
	};

	// Adding and removing a single applied filter
	const onRemoveFilter = (section, filterType, ids) => {
		const newAppliedFilters = appliedFiltersList.filter(filter => {
			return !(filter.section === section && filter.filterType === filterType && ids.some(id => filter.id === id));
		});
		changeAppliedFilters(newAppliedFilters);
	};

	const handleClearFilters = () => {
		changeAppliedFilters([]);
	};

	const saveFilterHandler = filterName => {
		if (filterName === '' || filterName === null) {
			const newFilterNamesCount = savedFilters.filter(savedFilter =>
				savedFilter.name.toLowerCase().includes('new filter')
			).length;
			filterName = `New Filter ${newFilterNamesCount + 1}`;
		}
		saveFilters(filterName, viewer.id, filtersToObject(appliedFiltersList), filterSection, projectId, projectGroupId, () =>
			setSavingFilter(false)
		);
	};

	const onClickAway = () => {
		const filterRect = containerRef.current.getBoundingClientRect();
		const bodyRect = document.body.getBoundingClientRect();
		if (Math.round(filterRect.x + filterRect.width) === Math.round(bodyRect.width)) {
			handleCloseFilter();
		}
	};

	const deleteFilterHandler = filterId => {
		deleteSavedFilter(filterId, viewer.id);
	};

	const renameFilter = (id, name) => {
		renameSavedFilter(id, name);
		setRenamingFilter(null);
	};

	const renderButton = () => {
		if (iconOnly) {
			return (
				<Button
					isSquare
					onClick={() => (show ? handleCloseFilter() : setShow(true))}
					iconPosition={appliedFiltersList.length === 0 && 'last'}
					icon={appliedFiltersList.length === 0 ? color => <FilterIcon color={color} /> : null}
					variant={
						appliedFiltersList.length > 0 ? Button.VARIANT.PURPLE_FILLED : Button.VARIANT.VERY_LIGHT_GRAY_OUTLINE
					}
					showText={appliedFiltersList.length > 0}
					userpilot={userpilot || 'filter-button-icon'}
					cy={cy ? `${cy}-button` : ''}
				>
					{appliedFiltersList.length > 0 ? `(${appliedFiltersList.length})` : ''}
				</Button>
			);
		} else {
			return (
				<FilterButtonWrapper>
					{savedFilters.length > 0 ? (
						<FilterSlider
							intl={intl}
							favouredFilters={savedFilters.slice(0, 3)}
							appliedFiltersList={appliedFiltersList}
							renamingFilter={renamingFilter}
							changeAppliedFilters={filters => changeAppliedFilters(filters)}
							renameFilter={(id, name) => renameFilter(id, name)}
						/>
					) : null}

					{appliedFiltersList.length === 0 ? (
						<Button
							icon={color => <FilterIcon color={color} />}
							iconPosition="last"
							onClick={() => (show ? handleCloseFilter() : setShow(true))}
							size={Button.SIZE.STANDARD}
							variant={
								appliedFiltersList.length > 0
									? Button.VARIANT.PURPLE_FILLED
									: Button.VARIANT.VERY_LIGHT_GRAY_OUTLINE
							}
							userpilot={userpilot || 'filter-button'}
							cy={cy ? `${cy}-button` : ''}
						>
							{intl.formatMessage({id: 'common.filter-as-verb'})}
						</Button>
					) : (
						<Button
							onClick={() => (show ? handleCloseFilter() : setShow(true))}
							size={Button.SIZE.STANDARD}
							variant={
								appliedFiltersList.length > 0
									? Button.VARIANT.PURPLE_FILLED
									: Button.VARIANT.VERY_LIGHT_GRAY_OUTLINE
							}
							userpilot={userpilot || 'filter-button'}
							cy={cy ? `${cy}-button` : ''}
						>
							{`${intl.formatMessage({id: 'common.filter-as-verb'})} ${
								appliedFiltersList.length > 0 ? `(${appliedFiltersList.length})` : ''
							}`}
						</Button>
					)}
				</FilterButtonWrapper>
			);
		}
	};

	const showSavedFilters = () => {
		return savedFilters.length > 0 || savingFilter;
	};

	const queryRenderVariables = {};
	if (companyProjectId) {
		queryRenderVariables.projectId = companyProjectId.toString();
	}
	if (companyProjectGroupId) {
		queryRenderVariables.groupId = companyProjectGroupId.toString();
	}

	return (
		<>
			{renderButton()}
			{ReactDOM.createPortal(
				<ClickAwayListener onClickAway={onClickAway}>
					<Container
						ref={containerRef}
						className={show ? 'slide-in' : ''}
						width={535}
						noMenu={noMenu}
						data-cy={cy ? cy : ''}
					>
						<CloseContainer showSaved={showSavedFilters()}>
							<CrossIconOld color={'#535353'} onClick={() => handleCloseFilter()} />
						</CloseContainer>
						{showSavedFilters() && (
							<SavedFiltersSection
								intl={intl}
								savedFilters={savedFilters}
								appliedFilters={appliedFiltersList}
								changeAppliedFilters={changeAppliedFilters.bind(this)}
								showSaving={savingFilter}
								saveFilter={filterName => saveFilterHandler(filterName)}
								deleteFilter={filterId => deleteFilterHandler(filterId)}
								renamingFilter={renamingFilter}
								setRenamingFilter={id => setRenamingFilter(id)}
								validateRenameFilter={(id, name) => renameFilter(id, name)}
							/>
						)}
						<QueryRenderContainer>
							{show && (
								<ForecastQueryRenderer
									key="query-render-new-filter"
									query={FilterQueryContentQuery}
									componentName="new_filter"
									showLoader={true}
									variables={{...queryRenderVariables}}
									customLoader={() => <InlineLoader />}
									render={(relayProps, retry) => {
										return (
											<FilterQueryContent
												intl={intl}
												{...relayProps}
												onAddFilter={onAddFilter}
												onRemoveFilter={onRemoveFilter}
												appliedFiltersList={appliedFiltersList}
												defaultSection={defaultSection}
												taskFilters={taskFilters}
												timeRegFilters={timeRegFilters}
												invoiceFilters={invoiceFilters}
												projectFilters={projectFilters}
												skillFilters={skillFilters}
												labelFilters={labelFilters}
												peopleFilters={peopleFilters}
												onClearFilters={handleClearFilters}
												onRemoveFilters={onRemoveFilter}
												clickOnSave={() => setSavingFilter(true)}
											/>
										);
									}}
								/>
							)}
						</QueryRenderContainer>
					</Container>
				</ClickAwayListener>,
				document.querySelector('#root-portal-container')
			)}
		</>
	);
};

FilterWrapper.propTypes = {
	defaultSection: PropTypes.oneOf([
		FILTER_SECTIONS.PROJECTS,
		FILTER_SECTIONS.TASKS,
		FILTER_SECTIONS.PEOPLE,
		FILTER_SECTIONS.SKILLS,
		FILTER_SECTIONS.LABELS,
	]).isRequired,
	show: PropTypes.bool,
	onClose: PropTypes.func,
	userpilot: PropTypes.string,
	cy: PropTypes.string,
};

FilterWrapper.defaultProps = {
	onClose: () => false,
	taskFilters: [],
	projectFilters: [],
	peopleFilters: [],
	timeRegFilters: [],
	onFiltersChange: () => false,
};

export default injectIntl(FilterWrapper);
